import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export interface FormGroupProps {
  children?: ReactNode | null;
  className?: string;
  hasError?: boolean;
  dataTestAttrs?: DataTestAttrs;
  disableBottomMargin?: boolean;
}

function FormGroup(props: FormGroupProps): JSX.Element {
  const className = classNames(
    props.className,
    'form-group',
    {
      'has-error': props.hasError,
    },
    props.disableBottomMargin ? css(styles.marginBottomZero) : undefined
  );
  return (
    <div className={className} {...getTestProps(props.dataTestAttrs)}>
      {props.children}
    </div>
  );
}
FormGroup.displayName = 'FormGroup';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const propTypes: any = {
  children: PropTypes.node,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  dataTestAttrs: PropTypes.object,
};
FormGroup.propTypes = propTypes;

export default FormGroup;

const styles = StyleSheet.create({
  marginBottomZero: {marginBottom: 0},
});
